module.exports = __webpack_public_path__ + "img/miniProgramCode.f61e8a01.png";